import { Button, TextInput } from "../../UI";
import React, { useContext, useRef } from "react";

import { DigitizerContext } from "../../contexts/digitizer.context";

const VerifyStudent = ({ onClick }) => {
  const { verifyStudent } = useContext(DigitizerContext);

  const inputRef = useRef();

  const submitHandler = (e) => {
    e.preventDefault();
    verifyStudent(inputRef.current.value);
    onClick();
  };
  return (
    <form onSubmit={submitHandler}>
      <p>check alumni</p>
      <TextInput placeholder="Matric Number" required ref={inputRef} />
      <Button type="submit">next</Button>
    </form>
  );
};

export default VerifyStudent;
